import { useMutation } from 'react-query';
import type { IUserFingerprintData } from 'services/FingerprintService/fingerprint.model';
import { FingerprintService } from 'services/FingerprintService/fingerprint.service';

export const useCheckUserFingerprintData = () =>
  useMutation({
    mutationFn: (data: IUserFingerprintData) => FingerprintService.checkFingerprint(data),
    mutationKey: ['checkUserFingerprintData'],
  });
